import { Component, output } from '@angular/core';
import { IconComponent } from '@components/icon/icon.component';

@Component({
  selector: 'app-hamburger-bottom-nav',
  imports: [IconComponent],
  templateUrl: './hamburger-bottom-nav.component.html',
  styleUrl: './hamburger-bottom-nav.component.scss'
})
export class HamburgerBottomNavComponent {
  public readonly appsRequested = output<void>();
  public readonly profileRequested = output<Event>();
  public readonly logoutRequested = output<void>();
}
